import React, { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import useFetchIntervenants from '../hooks/useFetchIntervenants';

import Loader from '../components/Loader';
import ListIntervenant from '../components/ListIntervenant';

const IntervenantList = () => {
    const navigate = useNavigate();
    const { intervenants, fetchIntervenants, loading, error, fetchAddIntervenant } = useFetchIntervenants();

    const didFetchRef = useRef(false);

    useEffect(() => {
        if (didFetchRef.current) return;
        didFetchRef.current = true;
        fetchIntervenants();
    }, [fetchIntervenants]);

    const handleRowDoubleClick = (event) => {
        const clickedRowData = event.rowData;
        console.log(clickedRowData);
        const uuid = clickedRowData.UUID_;
        if (uuid) navigate(`/intervenants/${uuid}`);
    };
    // if (loading) {
    //     return <div className="flex flex-1 justify-center items-center"><Loader /></div>;
    // }

    return (
        <>
        <div class="flex-1 px-6 py-4 lg:px-10">
                <div class="gap-6 grid grid-cols-12">
                    <div class="gap-6 grid grid-cols-12 col-span-12 xxl:col-span-9">
                        <div class="col-span-12">

                            <ListIntervenant lstIntervenants={intervenants} handleRowDoubleClick={handleRowDoubleClick} loading={loading} ExclusivePage={true} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default IntervenantList;
